export default "__VITE_ASSET__B9Dy11Xg__"